import * as Yup from "yup";

const ForgetPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("Provide a valid email")
    .required("Email is required"),
});

export default ForgetPasswordSchema;
